// extracted by mini-css-extract-plugin
export default {"logo":"PrivateLogo_logo__Ow8kE","logo__image":"PrivateLogo_logo__image__IYKmq"};